import * as React from "react";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  TextField,
  Typography,
  Hidden,
  Collapse,
  makeStyles,
} from "@material-ui/core";
import { MUIAdornment, MUIBlock, MUISelect, themeVariables } from "../";
import { SvgIcon } from "../../../../components";
import { tl, cssHidden } from "../../../../utils";
import { FilterSimple } from "./filter";
import * as styles from "./styles.scss";
import ChevronDown from "../../../../components/Icons/chevronDown";

interface IProps {
  disabled?: boolean;
  sortOptionsList?: {
    value: string;
    label: string;
  }[];
  sortBy?: string;
  onFilterSend: (data: {
    search: string;
    sortBy?: string;
    sortOrder?: "asc" | "desc";
  }) => void;
  delay?: number;
  title?: string;
  children?: any;
  data?: any;
  variant?: "filled" | "outlined" | "standard";
  noBlockStyle?: any;
  isCollapsible?: boolean;
}

export const MUIFilter: React.FC<IProps> = (props) => {
  const classes = useStyles();
  const throttleTO = React.useRef<ReturnType<typeof setTimeout>>(null);
  const [isCollapsed, setCollapsed] = React.useState(props.isCollapsible || false);
  const [search, setSearch] = React.useState("");
  const [sortBy, setSortBy] = React.useState(
    props.sortBy ||
      (props.sortOptionsList && props.sortOptionsList[0].value) ||
      ""
  );
  const [sortOrder, setSortOrder] = React.useState<"asc" | "desc">("desc");

  React.useEffect(() => {
    filterSendThrottle();
  }, [search, sortBy, sortOrder]);

  const filterSend = () => {
    props.onFilterSend({
      search,
      sortBy,
      sortOrder,
    });
  };
  const onSortBy = (e: any) => {
    setSortBy(e.target.value);
  };
  const onSortOrder = () => {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const filterSendThrottle = () => {
    clearTimeout(throttleTO.current);
    throttleTO.current = setTimeout(filterSend, props.delay || 1000);
  };

  const filter = (
    <Grid container>
      {props.title ? (
        <Box
          clone
          display="flex"
          alignItems="center"
          borderRight={themeVariables.border}
          className={cssHidden.onlyXs}
        >
          <Grid item>
            <Box p={2}>
              <Typography variant="subtitle1">{props.title}</Typography>
            </Box>
          </Grid>
        </Box>
      ) : null}
      <Grid item xs>
        <Box
          py={props.noBlockStyle ? 1 : 2}
          px={2}
          className={props.variant === "filled" ? "MuiFilledInputWhite" : null}
        >
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm>
              <FilterSimple
                disabled={props.disabled}
                search={search}
                setSearch={setSearch}
                onFilterSend={filterSend}
                variant={props.variant || "outlined"}
              />
            </Grid>

            {props.isCollapsible && 
              <div 
                onClick={() => setCollapsed((prev) => !prev)}
                className={classes.sortText}
              >
                {tl('Сортировка')} 
                <ChevronDown 
                  style={{transform: !isCollapsed ? 'rotate(180deg)': 'rotate(0deg)', transformOrigin: '50% 50%', transitionDuration: '100ms'}} />
              </div>}
           
            {props.sortOptionsList?.length ? (
              <Grid item xs={12} sm={4} component={Collapse} mountOnEnter unmountOnExit timeout={0} in={!isCollapsed}>
                <Grid container spacing={1} wrap="nowrap">
                  <Grid item xs zeroMinWidth>
                    <MUISelect
                      variant={props.variant || "outlined"}
                      fullWidth={props.variant === "filled" ? false : true}
                      value={sortBy}
                      disabled={props.disabled}
                      onChange={onSortBy}
                    >
                      {props.sortOptionsList.map(
                        (
                          option: { value: string; label: string },
                          i: number
                        ) => (
                          <MenuItem
                            key={`${i}_${option.value}`}
                            value={option.value}
                          >
                            {option.label}
                          </MenuItem>
                        )
                      )}
                    </MUISelect>
                  </Grid>
                  {sortBy === "manual" ? null : (
                    <Grid
                      item
                      component="button"
                      aria-label={tl("Порядок сортировки")}
                      onClick={onSortOrder}
                      disabled={props.disabled}
                      className={styles.sortOrder}
                    >
                      <SvgIcon type="fs-sort" modifier={sortOrder} />
                    </Grid>
                  )}
                </Grid>
              </Grid>
            ) : null}
            {React.Children.toArray(props.children).some(el => React.isValidElement(el)) ? (
              <Grid item xs={12} sm="auto">
                {props.children}
              </Grid>
            ) : null}
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );

  return props.noBlockStyle ? (
    <Box {...props.noBlockStyle}>{filter}</Box>
  ) : (
    <MUIBlock mb={2} pInner={0} data={props.data}>
      {filter}
    </MUIBlock>
  );
};


const useStyles = makeStyles((theme) =>({
  sortText: {
    display: 'inline-flex',
    alignItems: 'center',
    color: 'black',
    fontSize: 13,
    fontFamily: 'SF UI Text',
    fontWeight: 400,
    wordWrap: 'break-word',
    cursor: 'pointer',
    marginLeft: 10,
    '& svg': {
      marginLeft: 4,
      color: theme.palette.primary.light,
      fontSize: 20,
    }
  }
}))
